/**
 * Frontend-specific logger for the Akem web application
 * Uses the shared logger with Vite environment detection
 */

import { Logger, LogLevel } from '@akem/shared';

// Create frontend logger with proper environment detection
const isDev = import.meta.env.DEV;

const frontendLogger = new Logger({
  level: isDev ? LogLevel.DEBUG : LogLevel.WARN,
  enableColors: true,
  enableTimestamps: true,
});

// Create singleton instances
export const logger = frontendLogger;
export const configLogger = frontendLogger.child('CONFIG');
export const apiLogger = frontendLogger.child('API');
export const uiLogger = frontendLogger.child('UI');
export const healthLogger = frontendLogger.child('HEALTH');

// Export types and classes for advanced usage
export { Logger, LogLevel } from '@akem/shared';